import MessageListComponent from './component/MessageListComponent';
import { Nav } from 'react-bootstrap';
import './component/MessageListComponent.scss';
import { NoMessagesFound } from 'src/Member/img/NotificationSVG';

function MessagesList({
  ListUser,
  selectedIndex,
  data = [],
  getSanitizedContent,
}) {
  return (
    <div>
      <div className="scroll">
        <Nav
          variant="pills"
          className="flex-column msggrpTabs message-mgt nav nav-pills"
          style={{ minHeight: data?.length === 0 ? '175px' : 'auto' }}
        >
          {data?.length === 0 && (
            <>
              <div className="d-flex flex-column pt-5 pb-5">
                <div className="text-center">
                  <NoMessagesFound />
                </div>
                <div className="text-center pt-2 message-title">
                  This User does not have any messages yet!
                </div>
              </div>
            </>
          )}
          {data.map((item, index) => (
            <MessageListComponent
              key={index}
              item={item}
              onClick={() => ListUser(index, item)}
              itemIndex={index}
              selectedIndex={selectedIndex}
              getSanitizedContent={getSanitizedContent}
            />
          ))}
        </Nav>
      </div>
    </div>
  );
}

export default MessagesList;
